import React from 'react';
import { useIntl } from 'hooks';
import TwitterSearchResult from 'types/TwitterSearchResult';
import UpdateUserTwitterAccount from './UpdateUserTwitterAccount';
import Btn from 'components/shared/Btn';

interface Props {
  searchResults: TwitterSearchResult[];
  noResults?: boolean;
  isSaving?: boolean;
  onSave: (socialAccount: TwitterSearchResult) => void;
  width?: number;
}

export default function UpdateUserTwitterSearchResults(props: Props) {
  const { searchResults, noResults, onSave, width, isSaving } = props;
  const { t } = useIntl();

  return (
    <div style={{ width: width ? `${width - 16}px` : undefined }}>
      {noResults ? (
        <>
          <div className="text-dark font-bold leading-tight">
            {t('UpdateUserTwitter__NoResults')}
          </div>
        </>
      ) : (
        searchResults.map((searchResult) => (
          <SearchResultRow
            key={searchResult.id}
            searchResult={searchResult}
            onSave={() => onSave(searchResult)}
            isSaving={isSaving}
          />
        ))
      )}
    </div>
  );
}

interface SearchResultRowProps {
  searchResult: TwitterSearchResult;
  isSaving?: boolean;
  onSave: () => void;
}

function SearchResultRow(props: SearchResultRowProps) {
  const { searchResult, onSave, isSaving } = props;
  const { t } = useIntl();
  return (
    <div className="flex items-center border-b-default pl-1 py-1.5 last:border-b-0">
      <UpdateUserTwitterAccount account={searchResult} />

      <div className="ml-2 w-10 pr-1">
        <Btn size="sm" onClick={onSave} isLoading={isSaving}>
          {t('Button__Select')}
        </Btn>
      </div>
    </div>
  );
}
